import { render, staticRenderFns } from "./documentation-list.vue?vue&type=template&id=5c71eb99&scoped=true"
import script from "./documentation-list.vue?vue&type=script&lang=js"
export * from "./documentation-list.vue?vue&type=script&lang=js"
import style0 from "./documentation-list.vue?vue&type=style&index=0&id=5c71eb99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71eb99",
  null
  
)

export default component.exports